import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
export function UrgencyBanner() {
  const [timeLeft, setTimeLeft] = useState(15 * 60);
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => prev > 0 ? prev - 1 : 15 * 60);
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const minutes = Math.floor(timeLeft / 60);
  const seconds = timeLeft % 60;
  return <motion.div initial={{
    y: -50
  }} animate={{
    y: 0
  }} className="bg-red-600 text-white py-3 px-4 text-center font-bold text-sm md:text-base sticky top-0 z-50 shadow-lg" data-id="element-284">
      <span data-id="element-285">⏳ OFERTA EXPIRA EN: </span>
      <span className="font-mono bg-red-800/50 px-2 py-0.5 rounded mx-1" data-id="element-286">
        {String(minutes).padStart(2, '0')}:{String(seconds).padStart(2, '0')}
      </span>
      <span className="mx-2" data-id="element-287">|</span>
      <span data-id="element-288">🔥 CUPOS LIMITADOS</span>
    </motion.div>;
}